import {
  Action,
  ActionType,
  AbsenceResponse,
} from "models/dashboard/breakfast";
import createReducer from "../../createReducer";

export interface BreakfastReducerType {
  loading: boolean;
  error?: string;
  breakfastResponse?: AbsenceResponse;
}

const defaultState: BreakfastReducerType = {
  loading: false,
  error: undefined,
  breakfastResponse: undefined,
};

export const getBreakfastReducer = createReducer<BreakfastReducerType>(
  defaultState,
  {
    [ActionType.GET_BREAKFAST_CHART](state: BreakfastReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_BREAKFAST_CHART_ERROR](
      state: BreakfastReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_BREAKFAST_CHART_SUCCESS](
      state: BreakfastReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        breakfastResponse: action.payload,
      };
    },
  }
);
